module.exports = __webpack_public_path__ + "img/SKLB-Registro Tutor y Alumno.c38f21ff.png";